<template>
  <app-ag-grid
    title="Vendors"
    :columnDefs="columnDefs"
    :rowData="vendors"
    :loading="loading"
    :mobileCard="mobileCard"
    @refresh="fetchVendors"
    @add="onAdd"
    @row-dbl-click="
      (data) => $router.push({ path: `vendors/${data._id}/edit` })
    "
  ></app-ag-grid>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "VendorsPage",
  components: { AppAgGrid },

  data() {
    return {
      loading: false,

      columnDefs: [
        {
          headerName: "Vendor Name",
          field: "name",
          minWidth: 180,
        },

        {
          headerName: "Phone",
          field: "phone",
          minWidth: 140,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "Email",
          field: "email",
          minWidth: 220,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "GSTIN",
          field: "gstin",
          minWidth: 180,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "City",
          field: "city",
          minWidth: 140,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "State",
          field: "state",
          minWidth: 140,
          valueFormatter: (p) => p.value || "-",
        },

        {
          headerName: "Created",
          field: "createdAt",
          minWidth: 140,
          valueFormatter: (p) => {
            if (!p.value) return "-";
            const d = new Date(p.value);
            return `${String(d.getDate()).padStart(2, "0")}-${String(
              d.getMonth() + 1,
            ).padStart(2, "0")}-${d.getFullYear()}`;
          },
        },

        { headerName: "User", field: "userId.name", minWidth: 180 },
        { headerName: "User Email", field: "userId.email", minWidth: 220 },
      ],
    };
  },

  computed: {
    vendors() {
      return this.$store.state.vendors.vendors;
    },

    mobileCard() {
      return {
        title: (row) => row.name || "-",
        subtitle: (row) => row.email || row.phone || "-",
        fields: (row) => [
          { label: "Phone", value: row.phone || "-" },
          { label: "City", value: row.city || "-" },
        ],
        actions: (row) => [
          {
            label: "Edit",
            icon: "mdi-pencil-outline",
            color: "#475569",
            onClick: () => this.$router.push({ path: `vendors/${row._id}/edit` }),
          },
        ],
      };
    },
  },

  created() {
    this.fetchVendors();
  },

  methods: {
    async fetchVendors() {
      this.loading = true;
      try {
        await this.$store.dispatch("vendors/getVendors");
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({ path: "vendors/create" });
    },
  },
};
</script>
